import React from 'react'

const FulfilledRequestSummary = (props) => {
    return (
        <div>
          <table className="table request-summary-table cb-no-table-border">
            <thead>
              <tr className="tablerow table-header">
                  <th scope="col" colSpan="2"><strong>Validated</strong></th>
                  <th scope="col" colSpan="3"><strong>Processed</strong></th>
              </tr>
              <tr className="tablerow table-header">
                  <th scope="col"><strong>Total Records</strong></th>
                  <th scope="col"><strong>Error Records</strong></th>
                  <th scope="col"><strong>Records Processed</strong></th>
                  <th scope="col"><strong>Enrollments Created</strong></th>
                  <th scope="col"><strong>Enrollments Failed</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr className="tablerow">
                <td> {props.dataItems.RECORDS_COUNT ? <strong>{props.dataItems.RECORDS_COUNT}</strong> : <strong>0</strong> }</td>
                <td className="failcountcolor"> { props.dataItems.ERROR_COUNT ? <strong>{props.dataItems.ERROR_COUNT}</strong> : <strong>0</strong> } </td>
                <td> { props.dataItems.SUCCESS_COUNT ? <strong>{props.dataItems.SUCCESS_COUNT}</strong> : <strong>0</strong> } </td>
                <td className="successcountcolor"> { props.dataItems.APRO_SUCCESS_COUNT ? <strong>{props.dataItems.APRO_SUCCESS_COUNT}</strong> : <strong>0</strong> } </td>
                <td className="failcountcolor"> { props.dataItems.APRO_FAILED_COUNT ? <strong>{props.dataItems.APRO_FAILED_COUNT}</strong> : <strong>0</strong> } </td>
              </tr>
            </tbody>
          </table>
        </div>
    )
}

export default FulfilledRequestSummary
